export const formatCurrency = (value) => {
  // Remueve cualquier carácter que no sea número
  const numericValue = value.replace(/\D/g, '');
  // Convierte a número y aplica formato con separador de miles
  return new Intl.NumberFormat('es-CO').format(numericValue);
};
